import { COMMENT_MIMETYPE_PREFIX } from '../constants';

/**
 * Build a mimetype used for comment search results from the given string.
 */
export const buildCommentMimeType = (commentType: string) => `${COMMENT_MIMETYPE_PREFIX}${commentType}`;
